import React from 'react';

import { Typography, Button } from '@mui/material';

import { ReactComponent as CheckIconWhite } from '../../../../common/assets/icons/checkmark_icon_white.svg';

type Props = {
  isLoading: boolean;
  selectedAll: (select: boolean) => void;
  hasSelectedAll: boolean;
};

const UseAllCodesButton: React.FC<Props> = ({
  isLoading,
  selectedAll,
  hasSelectedAll,
}) => {
  return (
    <Button
      disabled={isLoading}
      sx={{
        minWith: '140px',
        borderRadius: '40px',
        flexShrink: 0,
        backgroundColor: hasSelectedAll
          ? 'darkBlue.main'
          : 'rgba(82, 86, 98, 0.60)',
        minWidth: '90px',
        marginTop: '6px',
        marginBottom: '6px',
      }}
      onClick={() => {
        selectedAll(!hasSelectedAll);
      }}
      color='darkBlue'
      variant='contained'
      startIcon={<CheckIconWhite />}
      disableElevation
    >
      <Typography color='#fff' fontWeight={500}>
        Use All
      </Typography>
    </Button>
  );
};

export default UseAllCodesButton;
